import { Season } from "../client";
import { NBASeasonSchema, WNBASeasonSchema } from "../client/schemas.gen";

export enum LEAGUE {
  NBA = "nba",
  WNBA = "wnba",
}
export type Context = "VIDEO" | "LEADERS" | "STANDINGS" | ""

export const getSeasons = (league: LEAGUE, context: Context = ""): Season[] => {
    const seasons = league === LEAGUE.NBA ? Object.values(NBASeasonSchema.enum) : Object.values(WNBASeasonSchema.enum)

    if (context === "VIDEO") {
        const firstSeason: Season = league === LEAGUE.NBA ? NBASeasonSchema.enum.find(s => s === "2013-14")! : WNBASeasonSchema.enum.find(s => s === "2014")!
        return seasons.slice(0, seasons.findIndex(season => season === firstSeason)) as Season[]
    } else if (context === "LEADERS") {
        if (league === LEAGUE.NBA) {
            const lastSeason: Season = NBASeasonSchema.enum.find(s => s === "1951-52")!
            return seasons.slice(0, seasons.findIndex(season => season === lastSeason) + 1) as Season[]
        }
        return seasons as Season[]
    } else if (context === "STANDINGS") {
        if (league === LEAGUE.NBA) {
            const lastSeason: Season = NBASeasonSchema.enum.find(s => s === "1946-47")!
            return seasons.slice(0, seasons.findIndex(season => season === lastSeason) + 1) as Season[]
        }
        return seasons as Season[]
    } else {
        return seasons as Season[]
    }
}

export const getSeasonRange = (league: LEAGUE, season: Season): [Date, Date] => {
    const range: [Date, Date] = league === LEAGUE.NBA ? [new Date(Number(season.slice(0,4)), 9, 1), new Date(Number(season.slice(0,2) + season.slice(-2)), 3, 30)] : [new Date(), new Date()]
    
    return range
}

export const nbaTeamsMap: Record<string, {
  abbreviation: string;
  nickname: string;
  founded: number;
  city: string;
  full_name: string;
  state: string;
  championships: number[];
}> = {
  "1610612737": {
    abbreviation: 'ATL',
    nickname: 'Hawks',
    founded: 1949,
    city: 'Atlanta',
    full_name: 'Atlanta Hawks',
    state: 'Georgia',
    championships: [1958]
},
  "1610612738": {
    abbreviation: 'BOS',
    nickname: 'Celtics',
    founded: 1946,
    city: 'Boston',
    full_name: 'Boston Celtics',
    state: 'Massachusetts',
    championships: [1957, 1959, 1960, 1961, 1962, 1963, 1964, 1965, 1966, 1968, 1969, 1974, 1976, 1981, 1984, 1986, 2008]
},
  "1610612739": {
    abbreviation: 'CLE',
    nickname: 'Cavaliers',
    founded: 1970,
    city: 'Cleveland',
    full_name: 'Cleveland Cavaliers',
    state: 'Ohio',
    championships: [2016]
},
  "1610612740": {
    abbreviation: 'NOP',
    nickname: 'Pelicans',
    founded: 2002,
    city: 'New Orleans',
    full_name: 'New Orleans Pelicans',
    state: 'Louisiana',
    championships: []
},
  "1610612741": {
    abbreviation: 'CHI',
    nickname: 'Bulls',
    founded: 1966,
    city: 'Chicago',
    full_name: 'Chicago Bulls',
    state: 'Illinois',
    championships: [1991, 1992, 1993, 1996, 1997, 1998]
},
  "1610612742": {
    abbreviation: 'DAL',
    nickname: 'Mavericks',
    founded: 1980,
    city: 'Dallas',
    full_name: 'Dallas Mavericks',
    state: 'Texas',
    championships: [2011]
},
  "1610612743": {
    abbreviation: 'DEN',
    nickname: 'Nuggets',
    founded: 1976,
    city: 'Denver',
    full_name: 'Denver Nuggets',
    state: 'Colorado',
    championships: [2023] },
  "1610612744": {
    abbreviation: 'GSW',
    nickname: 'Warriors',
    founded: 1946,
    city: 'Golden State',
    full_name: 'Golden State Warriors',
    state: 'California',
    championships: [1947, 1956, 1975, 2015, 2017, 2018, 2022]
},
  "1610612745": {
    abbreviation: 'HOU',
    nickname: 'Rockets',
    founded: 1967,
    city: 'Houston',
    full_name: 'Houston Rockets',
    state: 'Texas',
    championships: [1994, 1995]
},
  "1610612746": {
    abbreviation: 'LAC',
    nickname: 'Clippers',
    founded: 1970,
    city: 'Los Angeles',
    full_name: 'Los Angeles Clippers',
    state: 'California',
    championships: []
},
  "1610612747": {
    abbreviation: 'LAL',
    nickname: 'Lakers',
    founded: 1948,
    city: 'Los Angeles',
    full_name: 'Los Angeles Lakers',
    state: 'California',
    championships: [1949, 1950, 1952, 1953, 1954, 1972, 1980, 1982, 1985, 1987, 1988, 2000, 2001, 2002, 2009, 2010, 2020]
},
  "1610612748": {
    abbreviation: 'MIA',
    nickname: 'Heat',
    founded: 1988,
    city: 'Miami',
    full_name: 'Miami Heat',
    state: 'Florida',
    championships: [2006, 2012, 2013]
},
  "1610612749": {
    abbreviation: 'MIL',
    nickname: 'Bucks',
    founded: 1968,
    city: 'Milwaukee',
    full_name: 'Milwaukee Bucks',
    state: 'Wisconsin',
    championships: [1971, 2021]
},
  "1610612750": {
    abbreviation: 'MIN',
    nickname: 'Timberwolves',
    founded: 1989,
    city: 'Minnesota',
    full_name: 'Minnesota Timberwolves',
    state: 'Minnesota',
    championships: []
},
  "1610612751": {
    abbreviation: 'BKN',
    nickname: 'Nets',
    founded: 1976,
    city: 'Brooklyn',
    full_name: 'Brooklyn Nets',
    state: 'New York',
    championships: []
},
  "1610612752": {
    abbreviation: 'NYK',
    nickname: 'Knicks',
    founded: 1946,
    city: 'New York',
    full_name: 'New York Knicks',
    state: 'New York',
    championships: [1970, 1973]
},
  "1610612753": {
    abbreviation: 'ORL',
    nickname: 'Magic',
    founded: 1989,
    city: 'Orlando',
    full_name: 'Orlando Magic',
    state: 'Florida',
    championships: []
},
  "1610612754": {
    abbreviation: 'IND',
    nickname: 'Pacers',
    founded: 1976,
    city: 'Indiana',
    full_name: 'Indiana Pacers',
    state: 'Indiana',
    championships: []
},
  "1610612755": {
    abbreviation: 'PHI',
    nickname: '76ers',
    founded: 1949,
    city: 'Philadelphia',
    full_name: 'Philadelphia 76ers',
    state: 'Pennsylvania',
    championships: [1955, 1967, 1983]
},
  "1610612756": {
    abbreviation: 'PHX',
    nickname: 'Suns',
    founded: 1968,
    city: 'Phoenix',
    full_name: 'Phoenix Suns',
    state: 'Arizona',
    championships: []
},
  "1610612757": {
    abbreviation: 'POR',
    nickname: 'Trail Blazers',
    founded: 1970,
    city: 'Portland',
    full_name: 'Portland Trail Blazers',
    state: 'Oregon',
    championships: [1977]
},
  "1610612758": {
    abbreviation: 'SAC',
    nickname: 'Kings',
    founded: 1948,
    city: 'Sacramento',
    full_name: 'Sacramento Kings',
    state: 'California',
    championships: [1951]
},
  "1610612759": {
    abbreviation: 'SAS',
    nickname: 'Spurs',
    founded: 1976,
    city: 'San Antonio',
    full_name: 'San Antonio Spurs',
    state: 'Texas',
    championships: [1999, 2003, 2005, 2007, 2014]
},
  "1610612760": {
    abbreviation: 'OKC',
    nickname: 'Thunder',
    founded: 1967,
    city: 'Oklahoma City',
    full_name: 'Oklahoma City Thunder',
    state: 'Oklahoma',
    championships: [1979]
},
  "1610612761": {
    abbreviation: 'TOR',
    nickname: 'Raptors',
    founded: 1995,
    city: 'Toronto',
    full_name: 'Toronto Raptors',
    state: 'Ontario',
    championships: [2019]
},
  "1610612762": {
    abbreviation: 'UTA',
    nickname: 'Jazz',
    founded: 1974,
    city: 'Utah',
    full_name: 'Utah Jazz',
    state: 'Utah',
    championships: []
},
  "1610612763": {
    abbreviation: 'MEM',
    nickname: 'Grizzlies',
    founded: 1995,
    city: 'Memphis',
    full_name: 'Memphis Grizzlies',
    state: 'Tennessee',
    championships: []
},
  "1610612764": {
    abbreviation: 'WAS',
    nickname: 'Wizards',
    founded: 1961,
    city: 'Washington',
    full_name: 'Washington Wizards',
    state: 'District of Columbia',
    championships: [1978]
},
  "1610612765": {
    abbreviation: 'DET',
    nickname: 'Pistons',
    founded: 1948,
    city: 'Detroit',
    full_name: 'Detroit Pistons',
    state: 'Michigan',
    championships: [1989, 1990, 2004]
},
  "1610612766": {
    abbreviation: 'CHA',
    nickname: 'Hornets',
    founded: 1988,
    city: 'Charlotte',
    full_name: 'Charlotte Hornets',
    state: 'North Carolina',
    championships: [] }
};

export const wnbaTeamsMap: Record<string, {
  abbreviation: string;
  nickname: string;
  founded: number;
  city: string;
  full_name: string;
  state: string;
  championships: number[];
}> = {
  "1611661313": {
    abbreviation: "NYL",
    nickname: "Liberty",
    founded: 1997,
    city: "New York",
    full_name: "New York Liberty",
    state: "New York",
    championships: []
  },
  "1611661317": {
    abbreviation: "PHO",
    nickname: "Mercury",
    founded: 1997,
    city: "Phoenix",
    full_name: "Phoenix Mercury",
    state: "Arizona",
    championships: [2007, 2009, 2014]
  },
  "1611661319": {
    abbreviation: "LVA",
    nickname: "Aces",
    founded: 1997,
    city: "Las Vegas",
    full_name: "Las Vegas Aces",
    state: "Nevada",
    championships: [2022, 2023]
  },
  "1611661320": {
    abbreviation: "LAS",
    nickname: "Sparks",
    founded: 1997,
    city: "Los Angeles",
    full_name: "Los Angeles Sparks",
    state: "California",
    championships: [2001, 2002, 2016]
  },
  "1611661321": {
    abbreviation: "DAL",
    nickname: "Wings",
    founded: 1998,
    city: "Dallas",
    full_name: "Dallas Wings",
    state: "Texas",
    championships: [2003, 2006, 2008]
  },
  "1611661322": {
    abbreviation: "WAS",
    nickname: "Mystics",
    founded: 1998,
    city: "Washington",
    full_name: "Washington Mystics",
    state: "District of Columbia",
    championships: [2019]
  },
  "1611661323": {
    abbreviation: "CON",
    nickname: "Sun",
    founded: 1999,
    city: "Connecticut",
    full_name: "Connecticut Sun",
    state: "Connecticut",
    championships: []
  },
  "1611661324": {
    abbreviation: "MIN",
    nickname: "Lynx",
    founded: 1999,
    city: "Minnesota",
    full_name: "Minnesota Lynx",
    state: "Minnesota",
    championships: [2011, 2013, 2015, 2017]
  },
  "1611661325": {
    abbreviation: "IND",
    nickname: "Fever",
    founded: 2000,
    city: "Indiana",
    full_name: "Indiana Fever",
    state: "Indiana",
    championships: [2012]
  },
  "1611661328": {
    abbreviation: "SEA",
    nickname: "Storm",
    founded: 2000,
    city: "Seattle",
    full_name: "Seattle Storm",
    state: "Washington",
    championships: [2004, 2010, 2018, 2020]
  },
  "1611661329": {
    abbreviation: "CHI",
    nickname: "Sky",
    founded: 2005,
    city: "Chicago",
    full_name: "Chicago Sky",
    state: "Illinois",
    championships: [2021]
  },
  "1611661330": {
    abbreviation: "ATL",
    nickname: "Dream",
    founded: 2008,
    city: "Atlanta",
    full_name: "Atlanta Dream",
    state: "Georgia",
    championships: []
  }
};
